var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-risk-trace-list-container" },
    [
      _c(
        "v-centerForm",
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    model: _vm.searchForm,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单号", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户ID", prop: "userId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入用户ID", clearable: "" },
                        model: {
                          value: _vm.searchForm.userId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "userId", $$v)
                          },
                          expression: "searchForm.userId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "userPhone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号", clearable: "" },
                        model: {
                          value: _vm.searchForm.userPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "userPhone", $$v)
                          },
                          expression: "searchForm.userPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "风险等级", prop: "riskLevel" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择风险等级",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.riskLevel,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "riskLevel", $$v)
                            },
                            expression: "searchForm.riskLevel",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "低风险", value: "LOW" },
                          }),
                          _c("el-option", {
                            attrs: { label: "中风险", value: "MEDIUM" },
                          }),
                          _c("el-option", {
                            attrs: { label: "高风险", value: "HIGH" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "风控决策", prop: "decision" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择风控决策",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.decision,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "decision", $$v)
                            },
                            expression: "searchForm.decision",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "允许", value: "ALLOW" },
                          }),
                          _c("el-option", {
                            attrs: { label: "拦截", value: "BLOCK" },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "需要3DS验证",
                              value: "REQUIRE_3DS",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "风险分值" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "最小值", clearable: "" },
                        model: {
                          value: _vm.searchForm.totalScoreMin,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "totalScoreMin", $$v)
                          },
                          expression: "searchForm.totalScoreMin",
                        },
                      }),
                      _c("span", { staticStyle: { margin: "0 5px" } }, [
                        _vm._v("-"),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "最大值", clearable: "" },
                        model: {
                          value: _vm.searchForm.totalScoreMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "totalScoreMax", $$v)
                          },
                          expression: "searchForm.totalScoreMax",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务类型", prop: "businessType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择业务类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.businessType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "businessType", $$v)
                            },
                            expression: "searchForm.businessType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "订单", value: "ORDER" },
                          }),
                          _c("el-option", {
                            attrs: { label: "改签", value: "CHANGE" },
                          }),
                          _c("el-option", {
                            attrs: { label: "退款", value: "REFUND" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "检测时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.searchForm.checkTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "checkTimeRange", $$v)
                          },
                          expression: "searchForm.checkTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.refresh },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-tableEncapsulation",
        {
          attrs: {
            loading: _vm.loadingBtn.tableLoading,
            columnData: _vm.columnData,
            tableSize: _vm.pagination.size,
            tableData: _vm.tableData,
            tableTotal: _vm.pagination.total,
            currentPage: _vm.pagination.current,
          },
          on: {
            currentPage: _vm.handleCurrentChange,
            sizeChange: _vm.handleSizeChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              slot: "riskLevel",
              label: "风险等级",
              align: "center",
              width: "100px",
            },
            slot: "riskLevel",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getRiskLevelTagType(scope.row.riskLevel),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getRiskLevelText(scope.row.riskLevel)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "decision",
              label: "风控决策",
              align: "center",
              width: "120px",
            },
            slot: "decision",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getDecisionTagType(scope.row.decision),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getDecisionText(scope.row.decision)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "operate",
              label: "操作",
              align: "center",
              width: "100px",
              fixed: "right",
            },
            slot: "operate",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }